export default __webpack_public_path__ + "static/media/Techsophy-logo.49eb9b6f.svg";